import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ContactItemEdit } from "./contact-item.edit";
import { emptyContact, IContactItemForm } from "./table-contacts.models";

export const ContactItemAdd: FC<IContactItemForm> = ({
  index,
  setValue,
  fieldName,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <ContactItemEdit
          fieldName={fieldName}
          setValue={setValue}
          value={emptyContact}
          index={index}
          onCancel={() => setAddNewOpenedState(false)}
        />
      )}
      {!isAddNewOpened && (
        <div className="add_item_button_wrapper">
          <Button type="button" onClick={() => setAddNewOpenedState(true)}>
            <Add />
            {t("general.APPEND")}
          </Button>
        </div>
      )}
    </>
  );
};
